import React, { use } from "react";
import { useEffect } from "react";
const ReservationConfirmed = ({setInProgress,description}) => {
    

    // const generatePdf = () => {
    //     const normalizeText = (text) => {
    //         return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    //     }

    //     console.log(description)
    //     const doc = new jsPDF();
    //     doc.setFont("helvetica");
    //     doc.setFontSize(12);
    //     doc.text("Potwierdzenie rezerwacji", 20, 20);
    //     doc.line(20, 22, 100, 22);
    //     const lines = description
    //     .split("\n")
    //     .filter((line) => line.trim() !== "")
    //     .map(line => normalizeText(line.trim()));
      
    //     lines.forEach((line, index) => {
    //         doc.text(line, 20, 30 + index * 10);
    //     });
    //     doc.save();
    // }

    useEffect(() => {
        setInProgress(false)
    },[])

    return (
        <div>
            <div id="reservation-confirmed">
                <div className="icon-container">
                    <img src="/Photos/correct.webp" alt="Ikona potwierdzająca rezerwacje"></img>
                </div>
                <span><b>Rezerwacja potwierdzona!</b></span>
                <h3>Niedługo się z Tobą skontaktujemy w sprawie rezerwacji!</h3>
            {/* <button onClick={generatePdf}>Pobierz potwierdzenie</button> */}
            </div>
        </div>
    )
}


export default ReservationConfirmed;